import HeroSection from "@/sections/HeroSection";
import TrustBar from "@/sections/TrustBar";
import ProofSection from "@/sections/ProofSection";
import AgentsSection from "@/sections/AgentsSection";
import ClientLogosBar from "@/sections/ClientLogosBar";
import PlatformSection from "@/sections/PlatformSection";
import PracticeAreasSection from "@/sections/PracticeAreasSection";
import ThesisSection from "@/sections/ThesisSection";
import TestimonialsSection from "@/sections/TestimonialsSection";
import FoundersNoteSection from "@/sections/FoundersNoteSection";
import FirmOperationsSnapshot from "@/sections/FirmOperationsSnapshot";
import FAQSection from "@/sections/FAQSection";
import CTASection from "@/sections/CTASection";

const HomePage = () => (
    <main>
        <HeroSection />
        <ClientLogosBar />
        <div className="cv-auto"><AgentsSection /></div>
        <TrustBar />
        <div className="cv-auto"><ProofSection /></div>
        <div className="cv-auto"><PlatformSection /></div>
        <div className="cv-auto"><ThesisSection /></div>
        <div className="cv-auto"><FoundersNoteSection /></div>
        <div className="cv-auto"><FirmOperationsSnapshot /></div>
        <div className="cv-auto"><TestimonialsSection /></div>
        <div className="cv-auto"><PracticeAreasSection /></div>
        <div className="cv-auto"><FAQSection /></div>
        <div className="cv-auto"><CTASection /></div>
    </main>
);

export default HomePage;
